import styled from 'styled-components';
import { rgba } from 'polished';

import { c07071D, c14142E, cCC38FF, cFFFFFF } from '#/colors';

import { navItemStyles } from './styles';

export const PopoverMenu = styled.div`
  background-color: ${c14142E};
  border-radius: 7px;
  box-shadow: 0 0 40px 0 ${rgba(c07071D, 0.5)};
  display: grid;
  grid-auto-flow: row;
  padding: 8px;
  width: auto;

  position: relative;
  top: 24px;
  left: -10px;

  [data-reach-menu-link] {
    color: ${rgba(cFFFFFF, 0.7)};
    font-size: 13px;
    font-weight: 500;

    display: grid;
    grid-auto-flow: column;
    align-items: center;
    justify-content: start;

    gap: 12px;
    height: 36px;
    padding: 0px 16px 0px 12px;

    &:hover {
      color: ${cFFFFFF};
    }

    svg {
      color: ${cCC38FF};
    }
  }
`;

export const NavItemPopoverButtonWithArrow = styled.button`
  ${navItemStyles}
  gap: 6px;

  svg {
    margin-top: 3px;
  }

  &[aria-expanded='true'] {
    color: ${cFFFFFF};
    svg {
      rotate: 180deg;
    }
  }
`;

export const NavItemPopoverButton = styled.button`
  ${navItemStyles}
  font-size: 13px;
  padding: 5px 5px;
  margin: 0 -5px;
  gap: 6px;

  &[aria-expanded='true'] {
    color: ${cFFFFFF};
  }
`;
